<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="suppliers")
    modal-suppliers(:form='form', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.suppliers') }}:
            span {{ $t('strings.description', {attribute: $t('strings.suppliers')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="exportRecords")
                    vm-icon(icon="download-outline")
                    slot &nbsp;{{ $t('strings.export') }}
        vm-col.padding(vm-type="flex" vm-align="center" vm-justify="" vm-lg=5 vm-sm=5)
        vm-col.padding(vm-type="flex" vm-align="center" vm-justify="" vm-lg=6 vm-sm=6)
          vm-button(icon="sync-outline" @click="syncConfirm") {{ $t('suppliers.sync') }}
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="suppliers" )
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
                .d-flex.justify-content-between
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-date-picker.filter(type="daterange" :label="$t('suppliers.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('suppliers.'+ item)")
                    vm-order-by-item(value='code,asc' text='Codigo' direction='down')
                    vm-order-by-item(value='code,desc' text='Codigo' direction='up')
                    vm-order-by-item(value='business_name,asc' text='Rázon Social' direction='down')
                    vm-order-by-item(value='business_name,desc' text='Rázon Social' direction='up')
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list" style="display: none;")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('suppliers.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                  slot(v-if="column != 'status' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Suppliers')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalSuppliers = () => import('@/components/modals/ModalSuppliers.vue')

export default {
  name: 'Suppliers',
  components: {
    ModalImport,
    ModalSuppliers
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['code', 'business_name', 'rfc', 'cfdi_use', 'fiscal_regime', 'created_at'],
    columnsOrderBy: ['code', 'business_name'],
    attributeModal: 'code',
    status: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        code: '',
        business_name: '',
        rfc: '',
        cfdi_use: '',
        fiscal_regime: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['syncro', 'suppliers', 'catalog', 'pagination', 'filterParams'])
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'checkSyncro',
      'syncSuppliers'
    ]),
    syncConfirm () {
      this.checkSyncro().then(() => {
        if (this.syncro) {
          let t = this
          this.auxSyncRecord = () => {
            t.syncSuppliers().then(() => {
              this.loadRecords({ page: 1 })
            })
          }
          this.$vm.dialog({
            color: 'primary',
            title: this.$t('suppliers.initialize_sync'),
            text: this.$t('suppliers.sync_text'),
            accept: this.auxSyncRecord
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
